var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollegeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.327,
    height: 21.322,
    viewBox: "0 0 21.327 21.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "college-svgrepo-com-2",
    transform: "translate(0 -0.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36098",
    "data-name": "Group 36098",
    transform: "translate(0 0.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36097",
    "data-name": "Group 36097",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6656",
    "data-name": "Rectangle 6656",
    width: 21.327,
    height: 0.656,
    transform: "translate(0 20.666)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64737",
    "data-name": "Path 64737",
    d: "M124.111,258.179v-9.992H112.125v9.992h.656v-9.336h10.674v9.336Z",
    transform: "translate(-107.455 -237.852)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64738",
    "data-name": "Path 64738",
    d: "M145.333,272.843v-.656H144v.656h.338v7.675H144v.656h1.333v-.656h-.338v-7.675Z",
    transform: "translate(-138.002 -260.852)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64739",
    "data-name": "Path 64739",
    d: "M193.333,272.843v-.656H192v.656h.338v7.675H192v.656h1.333v-.656h-.338v-7.675Z",
    transform: "translate(-184.002 -260.852)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64740",
    "data-name": "Path 64740",
    d: "M241.333,272.843v-.656H240v.656h.339v7.675H240v.656h1.333v-.656h-.338v-7.675Z",
    transform: "translate(-230.003 -260.852)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64741",
    "data-name": "Path 64741",
    d: "M289.333,272.843v-.656H288v.656h.338v7.675H288v.656h1.333v-.656h-.338v-7.675Z",
    transform: "translate(-276.004 -260.852)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64742",
    "data-name": "Path 64742",
    d: "M337.333,272.724v-.656h-.338v-.005h-.656v.005H336v.656h.338V280.4H336v.656h1.333V280.4h-.338v-7.675Z",
    transform: "translate(-322.004 -260.733)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6657",
    "data-name": "Rectangle 6657",
    width: 13.329,
    height: 0.656,
    transform: "translate(3.999 9.336)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6658",
    "data-name": "Rectangle 6658",
    width: 4.332,
    height: 0.656,
    transform: "translate(0 13.001)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64743",
    "data-name": "Path 64743",
    d: "M87.442,7.154,80.111,4.822V.063h-.656V4.822L72.124,7.154v1.9H87.442ZM72.78,8.4V7.634l7-2.228,7,2.228V8.4Z",
    transform: "translate(-69.12 -0.063)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64744",
    "data-name": "Path 64744",
    d: "M275.66.188H272V.844h3v1.01h-3V2.51h3.66Z",
    transform: "translate(-260.67 -0.183)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64745",
    "data-name": "Path 64745",
    d: "M315,25.854h-3v.656h3.66V24.188h-1.328v.656H315Z",
    transform: "translate(-299.004 -23.183)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6659",
    "data-name": "Rectangle 6659",
    width: 0.656,
    height: 0.666,
    transform: "translate(10.336 6.665)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6660",
    "data-name": "Rectangle 6660",
    width: 3.666,
    height: 0.656,
    transform: "translate(0.335 13.989) rotate(0.183)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6661",
    "data-name": "Rectangle 6661",
    width: 3.666,
    height: 0.656,
    transform: "translate(0.335 17.333) rotate(0.183)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6662",
    "data-name": "Rectangle 6662",
    width: 0.656,
    height: 1.333,
    transform: "translate(1.005 15.329)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6663",
    "data-name": "Rectangle 6663",
    width: 0.656,
    height: 1.333,
    transform: "translate(2.671 15.329)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6664",
    "data-name": "Rectangle 6664",
    width: 0.656,
    height: 1.333,
    transform: "translate(1.005 18.661)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6665",
    "data-name": "Rectangle 6665",
    width: 0.656,
    height: 1.333,
    transform: "translate(2.671 18.661)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6666",
    "data-name": "Rectangle 6666",
    width: 4.332,
    height: 0.656,
    transform: "translate(16.995 13.001)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6667",
    "data-name": "Rectangle 6667",
    width: 3.666,
    height: 0.656,
    transform: "translate(20.993 14.656) rotate(-179.817)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6668",
    "data-name": "Rectangle 6668",
    width: 3.666,
    height: 0.656,
    transform: "translate(17.33 17.333) rotate(0.183)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6669",
    "data-name": "Rectangle 6669",
    width: 0.656,
    height: 1.333,
    transform: "translate(18 15.329)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6670",
    "data-name": "Rectangle 6670",
    width: 0.656,
    height: 1.333,
    transform: "translate(19.666 15.329)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6671",
    "data-name": "Rectangle 6671",
    width: 0.656,
    height: 1.333,
    transform: "translate(18 18.661)",
    fill: "#2580ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6672",
    "data-name": "Rectangle 6672",
    width: 0.656,
    height: 1.333,
    transform: "translate(19.666 18.661)",
    fill: "#2580ec"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeIcon);
export default __webpack_public_path__ + "static/media/college-Icon.82183f0d9ac4c49728a941cc520826cc.svg";
export { ForwardRef as ReactComponent };